// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"f24eecf1","171":"1a22937b","444":"a20dab1a","507":"85b1516e","968":"c0e1b85f"}[chunkId] + ".chunk.js";
};